import { DownloadOutlined } from "@ant-design/icons"
import { Button, ButtonProps } from "antd"
import React, { PropsWithChildren, useMemo } from "react"
import { CSVLink } from "react-csv"
import { BaseCsv } from "../modehistoryAndFanChangeHistory"
import dayjs from "dayjs"
import { timestampHeader } from "./core"
import { useBinInfoContext } from "src/queries/BinInfoContext"


type CsvDownloadButtonProps = {
  data: Array<BaseCsv> & Array<Record<string, any>>,
  headers: Array<string>,
  baseFileName: string,
} & ButtonProps

enum TimeType {
  Browser,
  UTC,
  Central,
  Custom,
}
export const CsvButton = (props: PropsWithChildren<CsvDownloadButtonProps>) => {
  const bininfo = useBinInfoContext();
  const [timeType, setTimeType] = React.useState(TimeType.Browser);
  const browerTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const adjustedData = useMemo(() => {
    if (timeType === TimeType.Browser) {
      return props.data?.map(row => {
        const originalTimestamp = dayjs(row[timestampHeader]);

        const adjustedTimestamp = originalTimestamp.tz(browerTimezone);
        return {...row, [timestampHeader]: adjustedTimestamp.format('YYYY-MM-DD hh:mm:ss A')}
      });
    }
    if (timeType === TimeType.UTC) {
      return props.data;
    }
    return props.data;

  }, [props.data, timeType]);

  const start = props.data?.[0]?.Timestamp;
  const end = props.data?.[props.data?.length - 1]?.Timestamp;
  const startFormatted = dayjs(start)?.format("YYYY-MM-DD");
  const endFormatted = dayjs(end)?.format("YYYY-MM-DD");
  const baseName = props.baseFileName ?? "data";
  const fullName = `${bininfo.name}_${baseName}_${startFormatted}_${endFormatted}.csv`

  return <CSVLink filename={fullName} data={adjustedData} headers={props.headers}>
    <Button icon={<DownloadOutlined />}>Download</Button>
  </CSVLink>
}